import { FC, Suspense, useEffect, useRef } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { navigateToMicroApp, syncOrchestratorUrl } from '@dvag/dfs-orchestrator-client/navigation';
import { Error404 } from '@dvag/dfs-ui-blocks/components';

import { route } from 'config/route';
import { ManageHousehold } from 'screen/ManageHousehold';
import { SavingType } from 'screen/SavingType/SavingType';
import { WishAndGoal } from 'screen/WishAndGoal/WishAndGoal';
import { PersonalDataForm } from './screen/PersonalDataForm';
import { RouterErrorBoundary } from './RouterErrorBoundary';
import { WishAndGoalSalesforce } from './screen/WishAndGoalSalesforce/WishAndGoalSalesforce';
import { sharedAppRoutes } from '@dvag/dfs-constant-config/shared-app-names';
import { appNames } from '@dvag/dfs-constant-config/app-names';
import { KundenstammdatenNamensaenderung } from './component/KundenstammdatenNamensaenderung/KundenstammdatenNamensaenderung';
import { AddressEdit } from './screen/AddressEdit/AddressEdit';

const {
  person,
  manageHousehold,
  createHousehold,
  wishesAndGoals,
  wishesAndGoalsWithSelectedPerson,
  wishesAndGoalsSalesforce,
  wishesAndGoalsSalesforceWithSelectedPerson,
  wishesAndGoalsHideFinancialGrade,
  wishesAndGoalsHideFinancialGradeWithSelectedPerson,
  savingType,
  personWithActiveForm,
  addressEdit,
  kssNameChange,
} = route;

const navigateToAdvisorDashboard = () => {
  navigateToMicroApp(appNames.advisor, sharedAppRoutes.advisor.householdSearch);
};

export const App = () => {
  const isInitialMount = useRef(true);
  const location = useLocation();

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else if (location.key) {
      syncOrchestratorUrl(`${location.pathname}`);
    }
  }, [location]);

  return (
    <Suspense fallback={null}>
      <RouterErrorBoundary>
        <Routes>
          <Route path={person} element={<PersonalDataForm />} />
          <Route path={addressEdit} element={<AddressEdit />} />
          <Route path={personWithActiveForm} element={<PersonalDataForm />} />
          <Route path={savingType} element={<SavingType />} />
          <Route path={createHousehold} element={<ManageHousehold />} />
          <Route path={manageHousehold} element={<ManageHousehold />} />
          <Route path={wishesAndGoals} element={<WishAndGoal />} />
          <Route path={wishesAndGoalsWithSelectedPerson} element={<WishAndGoal />} />
          <Route path={wishesAndGoalsSalesforce} element={<WishAndGoalSalesforce />} />
          <Route
            path={wishesAndGoalsSalesforceWithSelectedPerson}
            element={<WishAndGoalSalesforce />}
          />
          <Route
            path={wishesAndGoalsHideFinancialGrade}
            element={<WishAndGoal hideFinancialGrade />}
          />
          <Route
            path={wishesAndGoalsHideFinancialGradeWithSelectedPerson}
            element={<WishAndGoal hideFinancialGrade />}
          />
          <Route path={kssNameChange} element={<KundenstammdatenNamensaenderung />} />
          <Route path="*" element={<Error404 onAction={navigateToAdvisorDashboard} />} />
        </Routes>
      </RouterErrorBoundary>
    </Suspense>
  );
};

export const Router: FC = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
